// extracted by mini-css-extract-plugin
export default {"component":"ET7CV","carousel":"UBV3v","title":"p2bYy","tariff-tile":"E7b6M","button":"UChn2"};